import { useState } from 'react';
import { Phone, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '@/api/client';

interface Props {
  toNumber: string;
  orderId?: string | number;
  awbNo?: string;
  lrNo?: string;
  reason?: string;
  size?: 'sm' | 'md';
  className?: string;
  label?: string;
}

export function CallButton({ toNumber, orderId, awbNo, lrNo, reason, size = 'sm', className = '', label }: Props) {
  const [busy, setBusy] = useState(false);
  if (!toNumber) return null;
  const handle = async (e: React.MouseEvent) => {
    e.stopPropagation(); e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post('/ivr/call', { toNumber, orderId: orderId ? String(orderId) : undefined, awbNo, lrNo, reason });
      if (r.data?.ok) toast.success(`Call initiated to ${toNumber}`);
      else toast.error(`Call failed: ${r.data?.providerResponse ?? 'unknown'}`);
    } catch (e: any) {
      toast.error(e?.response?.data?.message ?? 'Call failed');
    } finally { setBusy(false); }
  };
  const sz = size === 'sm' ? 'p-1 text-xs' : 'px-2 py-1 text-sm';
  return (
    <button onClick={handle} disabled={busy}
      title={`Click to call ${toNumber}`}
      className={`inline-flex items-center gap-1 rounded bg-emerald-50 text-emerald-700 hover:bg-emerald-100 border border-emerald-200 transition disabled:opacity-50 ${sz} ${className}`}>
      {busy ? <Loader2 size={12} className="animate-spin" /> : <Phone size={12} />}
      {label}
    </button>
  );
}
